import React from "react";
import { NewFeedPictureModel } from "../../newfeeds/models/NewFeedModel";
import {
    CollageLayout, CollageLayoutManager, PhotoCollageStyle, PhotoSize
} from "../models/PhotoCollageModel";
import { PhotoShapeManager } from "./PhotoShapeManager";

export type CollageProps = {
    photos: NewFeedPictureModel[];
    photoManager: PhotoShapeManager;
    layout: CollageLayout;
}

export default function TwoPhotoView({ photos, photoManager, layout }: CollageProps) {
    const layoutManager = new CollageLayoutManager(layout);

    const style = new PhotoCollageStyle(
        photoManager.dimension.getSpacing(),
        layoutManager.isTall()
    );

    const getPhoto = (photo: NewFeedPictureModel): JSX.Element => {
        const isTall = layoutManager.isTall();

        return <>
            {photoManager.getRectangle(
                photo,
                PhotoSize.half,
                isTall ? PhotoSize.extraFull : PhotoSize.full,
                layoutManager.isTall()
            )}
        </>;
    }

    return <div style={{ display: "inline-block" }}>
        <div style={{
            float: style.outerFloat,
            paddingRight: style.paddingBottom,
            paddingBottom: style.paddingRight
        }}>
            {getPhoto(photos[0])}
        </div>
        <div style={{ float: style.innerFloat }}>
            {getPhoto(photos[1])}
        </div>
    </div>;
}